







































































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import PatientPathologyAddOrEdit from '@/components/patients/PatientPathologyAddOrEdit.vue';
@Component({
  components: { PatientPathologyAddOrEdit },
})
export default class PatientFilePathology extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  removeLoading: any = {
    pathologyId: '',
    status: false,
  };

  // Current language for pathologies
  get language() {
    return this.$pdc.helper?.isAnExistingLanguage(this.$store.getters['pdc/doctor/lang']);
  }
  // Patient pathologies status
  get hasPathologies() {
    return this.patient.infos.pathologies?.length;
  }
  get hasCustomPathologies() {
    return this.patient.infos.customPathologies?.length;
  }
  // Get gender letter for illustration
  get illustration() {
    const gender = this.patient!.infos.gender.toString() === '1' ? 'H' : 'F';
    const hasPathology = this.hasPathologies || this.hasCustomPathologies ? '' : '-unknown';
    return `patho${hasPathology}-${gender}`;
  }

  // Open pathology dialog
  addPatientPathology() {
    (this.$refs['add-edit-pathology-dialog'] as any).openAdd();
  }
  editPatientPathology(pathology: any) {
    (this.$refs['add-edit-pathology-dialog'] as any).openEdit(pathology);
  }

  // If date format is > current date
  dateFormat(date: string) {
    const diff = this.$moment().diff(date, 'months', false);
    if (diff <= 0) return this.$t('commons.standards.this-month');
    return this.$moment(date).fromNow();
  }
  // Remove patient pathology
  removePatientPathology(id: string) {
    try {
      this.$pdc.repository?.patchRessource({
        ressource: 'patients',
        params: {
          _id: this.patient!._id,
        },
        data: {
          $pull: {
            'infos.pathologies': {
              reference: id,
            },
          },
        },
      });
      this.removeLoading = {
        pathologyId: '',
        status: false,
      };
    } catch (e) {
      console.log(e);
    }
  }
  // Remove custom patient pathology
  removePatientCustomPathology(id: string) {
    try {
      this.$pdc.repository?.patchRessource({
        ressource: 'patients',
        params: {
          _id: this.patient!._id,
        },
        data: {
          $pull: {
            'infos.customPathologies': {
              _id: id,
            },
          },
        },
      });
    } catch (e) {
      console.log(e);
    }
  }
}
